var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"spx-sm-24 spx-xs-15 white spt-10 flex-wrap"},[_c('v-flex',{staticClass:"spx-lg-13",attrs:{"xs12":""}},[_c('BlogCarouselBlog',{attrs:{"blogs":_vm.blogs,"contexto":"blog"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }